export enum PageType {
  Payment = 1,
  Status = 2,
  UpdatePaymentMethod = 3,
}
